import React from 'react'
import * as Sentry from '@sentry/react'
import TagManager from '@sooro-io/react-gtm-module'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { sentryConfig } from './config/sentry'
import { gtmConfig } from './config/gtm'
import reportWebVitals from './reportWebVitals'
import { loadAffiliateVisitorScript } from './utils/Affiliate/loadAffiliateVisitorScript'
import { amConfig } from './config/affiliateManager'

if (sentryConfig.enabled) {
	Sentry.init(sentryConfig)
}

if (gtmConfig.enabled) {
	TagManager.initialize({
		gtmId: gtmConfig.gtmId,
	})
}

if (amConfig.enabled) {
	loadAffiliateVisitorScript()
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
